export default __webpack_public_path__ + "static/ppq-modal-images-83d1311ec59ab77459c7324bd6f21a48.png";